import Vue from 'vue'
import Vuex from 'vuex'

import permissions from './permissions'
import users from './users'
import sipua from './sipua'
import queues from './queues'
import conferences from './conferences'
import videoconfer from './video_conferences'
import videoConferenceOverlay from './video_conferences/overlay'
import videoConferenceConfig from './video_conferences/config'
import voicemails from './voicemails'
import licenses from './licenses'
import announcements from './announcements'
import availableExtensions from './available_extensions'
import cdrs from './cdrs'
import settings from './settings'
import callslog from './callslog'
import chat from './chat'
import userPictureProfiles from './user_picture_profiles'
import contacts from './contacts'
import currentUser from './current_user'
import parking from './parking'
import search from './search'
import ringStrategies from './ring_strategies'
import branding from './branding'
import sessions from './sessions'

import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const state = {
  authenticated: false,
  callPanelInitialized: false,
  pendingInitAfterRefresh: false,
  rmqhint: 0
}

const getters = {
  isAuthenticated: state => state.authenticated,
  callPanelInitialized: state => state.callPanelInitialized,
  pendingInitAfterRefresh: state => state.pendingInitAfterRefresh,
  rmqhint: state => state.rmqhint,
  sipuaStatus: () => sipua.state.status,
  sipuaClidName: () => sipua.state.clidName,
  sipuaClidNum: () => sipua.state.clidNum,
  sipuaExten: () => sipua.state.exten,
  sipuaSess: () => sipua.state.sessions,
  sipuaVmNum: () => sipua.state.vmnum,
  phoneShow: () => sipua.state.phoneShow,
  phoneDialNumber: () => sipua.state.phoneDialNumber,
  /* Show tel: URLs instead of directly calling a number via Call Panel. */
  showTelURLs: () => !permissions.getters.softphoneRead && settings.state.clickToDial.destination === 'callPanelDial',
  queues: () => queues.state.queues,
  conferences: () => conferences.state.conferences,
  missedCalls: state => state.callslog.missed,
  callsLog: state => state.callslog.calls,
  voicemails: () => voicemails.state.messages,
  uaMailbox: () => `${sipua.state.exten}@${sipua.state.uacfg.realm}`,
  countryCode: () => sipua.state.uacfg?.country?.toUpperCase()
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: (import.meta.env.NODE_ENV === 'development'), // state mutations only inside mutations!
  modules: {
    permissions,
    currentUser,
    users,
    sipua,
    queues,
    conferences,
    videoconfer,
    videoConferenceOverlay,
    videoConferenceConfig,
    voicemails,
    announcements,
    availableExtensions,
    cdrs,
    callslog,
    settings,
    chat,
    contacts,
    parking,
    search,
    userPictureProfiles,
    licenses,
    ringStrategies,
    branding,
    sessions
  }
})
